import { Link } from 'react-router-dom';
import { appsData } from '../data/apps';

const Briques = () => {
  // Messages marketing percutants pour chaque brique
  const briquesData = [
    {
      id: 'mobile',
      valueProposition: 'Trouvez votre parking en 3 secondes. Créez votre ticket en un clic. Payez en toute sécurité. Votre solution de stationnement intelligente dans la poche.',
      highlights: [
        'Géolocalisation en temps réel',
        'Paiement sécurisé instantané',
        'Notifications proactives',
        'Interface intuitive et rapide'
      ]
    },
    {
      id: 'controller',
      valueProposition: 'Contrôlez plus efficacement. Scannez instantanément. Vérifiez en un coup d\'œil. L\'outil terrain qui change la donne pour les contrôleurs.',
      highlights: [
        'Scan automatique de plaques',
        'Vérification instantanée',
        'Interface terrain optimisée',
        'Rapports automatisés'
      ]
    },
    {
      id: 'web-admin',
      valueProposition: 'Gérez tout votre écosystème. Analysez vos performances. Optimisez vos revenus. Le tableau de bord qui transforme la gestion de parking.',
      highlights: [
        'Dashboard analytics en temps réel',
        'Gestion centralisée complète',
        'Rapports détaillés et exports',
        'Administration simplifiée'
      ]
    },
  ];

  // Fusionner les données des briques avec appsData
  const briques = briquesData.map(briqueData => {
    const appData = appsData.find(app => app.id === briqueData.id);
    return {
      ...appData!,
      valueProposition: briqueData.valueProposition,
      highlights: briqueData.highlights
    };
  });

  return (
    <section id="briques" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Les 3 briques du système
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trois applications complémentaires qui travaillent ensemble pour offrir une expérience 
            optimale à tous les acteurs du système de parking.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {briques.map((brique) => (
            <div
              key={brique.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200 flex flex-col"
            >
              <div className={`bg-gradient-to-br ${brique.color} p-8 text-white`}>
                <div className="text-6xl mb-4">{brique.icon}</div>
                <h3 className="text-2xl font-bold mb-3">{brique.name}</h3>
              </div>
              
              <div className="p-6 flex-1 flex flex-col">
                {/* Liste avec checkmarks */}
                <div className="mb-6 flex-1">
                  <ul className="space-y-3">
                    {brique.highlights.map((highlight, idx) => (
                      <li key={idx} className="flex items-start text-gray-700">
                        <svg className="w-5 h-5 text-green-500 mr-3 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <span>{highlight}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Boutons */}
                <div className="mt-auto">
                  <Link
                    to={`/apps/${brique.id}`}
                    className="block w-full text-center py-3 px-6 bg-gray-100 text-gray-800 font-semibold rounded-lg hover:bg-gray-200 transition-colors duration-300"
                  >
                    Plus de détails
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section - Simplified */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-br from-primary-600 to-primary-800 rounded-2xl p-8 shadow-xl max-w-4xl mx-auto">
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4">
              Prêt à digitaliser votre gestion de parking ?
            </h3>
            <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
              Rejoignez la révolution du stationnement intelligent avec Tunisie Parking.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-6 py-3 bg-white text-primary-700 font-semibold rounded-lg shadow-lg hover:bg-gray-100 transition-all duration-300"
              >
                Nous contacter
              </Link>
              <Link
                to="/demo"
                className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg shadow-lg hover:bg-primary-400 transition-all duration-300"
              >
                Essayer la démo
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Briques;

